import { COLORS } from '@styles/colors'
import { FONTS } from '@styles/fonts'
import styled, { css } from 'styled-components'

export const RatingNumber = styled.span`
  font-size: 14px;
  font-family: ${FONTS.medium};
`

export const NumberOfReviews = styled.span`
  white-space: nowrap;
  font-size: 14px;
  color: ${COLORS.navi};
`

export const Rating = styled.div`
  color: ${COLORS.primary};
  display: flex;
  align-items: center;
  gap: 4px;

  svg {
    flex: 0 0 16px;
    width: 16px;
  }

  > div {
    display: flex;
    align-items: center;
    gap: 2px;
  }

  ${({ isVertical }) =>
    isVertical &&
    css`
      flex-direction: column;
      align-items: flex-start;
      gap: 4px;

      svg {
        flex: 0 0 20px;
        width: 20px;
        height: 20px;
      }

      ${NumberOfReviews} {
        font-size: 16px;
      }
    `}

  ${({ officeSidebar }) =>
    officeSidebar &&
    css`
      margin-bottom: 40px;
    `}
`
